module.exports = __webpack_public_path__ + "img/kareha2.d5dde493.jpg";